import { emailOTPClient, inferAdditionalFields } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const auth = createAuthClient({
  baseURL: import.meta.env.VITE_BACKEND_URL,
  basePath: '/api/v1/auth',
  plugins: [
    inferAdditionalFields({
      user: {
        role: {
          type: ['USER', 'ADMIN'],
          required: true,
        },
      },
    }),
    emailOTPClient(),
  ],
  fetchOptions: {
    credentials: 'include',
  },
})

export const { useSession } = auth

// Infer types from the auth client
type AuthClient = typeof auth
export type Session = AuthClient['$Infer']['Session']
export type User = Session['user']

// Redirect after auth helpers
const AUTH_REDIRECT_KEY = 'auth_redirect_url'

export function setAuthRedirect(url: string) {
  localStorage.setItem(AUTH_REDIRECT_KEY, url)
}

export function getAuthRedirect(): string | null {
  return localStorage.getItem(AUTH_REDIRECT_KEY)
}

export function clearAuthRedirect() {
  localStorage.removeItem(AUTH_REDIRECT_KEY)
}

function isValidRedirectUrl(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//')
}

export function consumeAuthRedirect(): string | null {
  const url = getAuthRedirect()
  if (url) {
    clearAuthRedirect()
    if (!isValidRedirectUrl(url)) return null
  }
  return url
}
